import { render, staticRenderFns } from "./DlgNotification.vue?vue&type=template&id=74118c27&scoped=true"
import script from "./DlgNotification.vue?vue&type=script&lang=js"
export * from "./DlgNotification.vue?vue&type=script&lang=js"
import style0 from "./DlgNotification.vue?vue&type=style&index=0&id=74118c27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74118c27",
  null
  
)

export default component.exports